import React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Skeleton from "@mui/material/Skeleton";
import { useQuery } from "@apollo/client";
import { GET_PERMIT_STATS, GetPermitStatsData } from "common/graphql";

interface StatCardProps {
  label: string;
  value: number;
  loading?: boolean;
  color?: string;
}

const StatCard: React.FC<StatCardProps> = ({ label, value, loading, color }) => {
  return (
    <Card variant="outlined" sx={{ height: "100%" }}>
      <CardContent>
        <Typography variant="body2" color="text.secondary" gutterBottom>
          {label}
        </Typography>
        {loading ? (
          <Skeleton width={60} height={40} />
        ) : (
          <Typography variant="h4" component="div" fontWeight={600} sx={{ color }}>
            {value.toLocaleString()}
          </Typography>
        )}
      </CardContent>
    </Card>
  );
};

export const PermitStatsCards: React.FC = () => {
  const { data, loading } = useQuery<GetPermitStatsData>(GET_PERMIT_STATS, {
    fetchPolicy: "cache-and-network",
  });

  const stats = [
    {
      label: "Total Permits",
      value: data?.totalPermits.aggregate.count ?? 0,
    },
    {
      label: "Active",
      value: data?.activePermits.aggregate.count ?? 0,
      color: "success.main",
    },
    {
      label: "Expired",
      value: data?.expiredPermits.aggregate.count ?? 0,
      color: "text.secondary",
    },
    {
      label: "Denied",
      value: data?.deniedPermits.aggregate.count ?? 0,
      color: "error.main",
    },
  ];

  return (
    <Box sx={{ overflow: "hidden" }}>
      <Grid container columnSpacing={2}>
        {stats.map((stat) => (
          <Grid item xs={6} sm={3} key={stat.label}>
            <StatCard label={stat.label} value={stat.value} loading={loading} color={stat.color} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default PermitStatsCards;
